import { styled } from 'styled-components'

import {
  FormattedMessage,
  Tag,
  TagFormat,
  TagType,
} from '@b-stock/fe-core/bstock-react'
import { BuyingFormatEnum } from '@b-stock/search-api-client'

import {
  getPrimaryBuyingFormat,
  useDisplayBuyingFormats,
} from '@/buyer-portal/helpers/auctions/buyingFormat'
import type { SearchResult } from '@/queries/listingSearchQuery'

import { SkeletonTextLine, TagSkeleton } from '../../ListingCardSkeleton/ui'

const StyledTag = styled(Tag)`
  padding-top: 4px;
  padding-bottom: 4px;
`

/**
 * `isFdBuyNow` comes from the caller rather than a First Dibs hook here, so
 * the tag only says BUY NOW where the price next to it is the early price.
 */
const BuyingFormat = ({
  listing,
  isFdBuyNow = false,
}: {
  listing: SearchResult
  isFdBuyNow?: boolean
}) => {
  let key: string
  let type: TagType

  const format = getPrimaryBuyingFormat(useDisplayBuyingFormats(listing))
  if (format === BuyingFormatEnum.BuyNow || isFdBuyNow) {
    key = 'buyNow'
    type = TagType.buy_now
  } else if (format === BuyingFormatEnum.MakeAnOffer) {
    key = 'makeOffer'
    type = TagType.make_offer
  } else {
    // Only other possibility (currently) is Auction
    key = 'auction'
    type = TagType.auction
  }
  return (
    <StyledTag format={TagFormat.type} type={type} data-testid="buying-format">
      <FormattedMessage id={`Auction.buyingFormat.${key}`} />
    </StyledTag>
  )
}

export default BuyingFormat

export const BuyingFormatSkeleton = () => (
  <TagSkeleton format={TagFormat.type} type={TagType.normal}>
    <SkeletonTextLine tag width="3rem" testIdSuffix="buying-format" />
  </TagSkeleton>
)
